import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { ensureIdField } from './ensure-id-field.js'
import { flattenFieldsWithoutIdCheck } from './flatten-fields-without-id-check.js'

export function flattenFields(fields: SchemaField[]): SchemaField[] {
  return flattenFieldsWithoutIdCheck(ensureIdField(fields))
}
